import { Theme, webLightTheme } from "@fluentui/react-components";

export const getAmcFluentV9Theme = (): Theme => {
    return webLightTheme;
};
